import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_MEDREFILL_INSTITUTIONS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetMedRefillInstitutionsRequestPayload,
  GetMedRefillInstitutionsResponsePayload,
} from '../types/getMedRefillInstitutions.type';

export const TAG_MEDREFILL_INSTITUTIONS = 'getMedRefillInstitutions';

export const getMedRefillInstitutions = <T extends BuilderType>(builder: T) =>
  builder.query<GetMedRefillInstitutionsResponsePayload, GetMedRefillInstitutionsRequestPayload>({
    providesTags: [TAG_MEDREFILL_INSTITUTIONS],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_MEDREFILL_INSTITUTIONS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetMedRefillInstitutionsResponsePayload>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
